import styled from "styled-components";
import breakpoints from "theme/breakpoints";
import CollaboratorPanel from "modules/dashboard/collaborator/CollaboratorPanel";
import DashHeader from "modules/dashboard/_common/DashHeader";
import DashHeaderActions from "modules/dashboard/_common/DashHeaderActions";
import OnSelectMenuProvider from "context/general/OnSelectMenu";
import CollapseProvider from "context/general/Collapse";
import { Column } from "styled/alignment/Column";
import Navbar from "components/commons/Navbar";

export default function CheckinPage() {
    return (
        <>
            <CollapseProvider>
                <OnSelectMenuProvider>
                    <StyledHeader>
                        <DashHeader userView />
                        <DashHeaderActions />
                    </StyledHeader>

                    <Container>
                        <CollaboratorPanel />
                    </Container>

                    <Navbar />
                </OnSelectMenuProvider>
            </CollapseProvider>
        </>
    )
};

const Container = styled(Column)`
  width: 100%;
  
  @media screen and (min-width: ${breakpoints.lg}) {
    margin-top: 100px;
  }
`;

const StyledHeader = styled.span`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;
